import React, { useState } from "react";
import axios from "axios";
import ModalOverlay from "components/UI/ModalOverlay";
import theme from "Theme/theme";
import Input from "components/UI/Input";
import Button from "components/UI/Button";
import { toast } from "react-toastify";
import { makeRequest, METHODS } from "common/request";
import { API_URL, ERROR_HANDLE } from "config/constants";
import { Constants } from "../../../../../common/constants";

const AppliedPromos = (props) => {
  const TITLE = "Applied Promos";
  const DELETE_ICON = require("../../../../../assets/images/waste-bin.png");

  const [promoCode, setPromoCode] = useState("");

  const handleApplyPromocode = () => {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/promos/apply/${promoCode}?userId=${localStorage.getItem(
          "flexitCurrentSingleUserID"
        )}`,
        {
          headers: {
            "x-access-token": access_token,
          },
        }
      )
      .then((res) => {
        props.refresh();
      })
      .catch((err) => {
        ERROR_HANDLE(err);
      });
  };

  const deletePromo = (promoId) => {
    const access_token = localStorage.getItem("access_token");
    axios
      .delete(
        `${API_URL}/promos/apply/${promoId}?userId=${localStorage.getItem(
          "flexitCurrentSingleUserID"
        )}`,
        {
          headers: {
            "x-access-token": access_token,
          },
        }
      )
      .then((res) => {
        props.refresh();
      })
      .catch((err) => {
        ERROR_HANDLE(err);
      });
  };
  return (
    <ModalOverlay
      modalStyle={style.modalStyle}
      header={TITLE}
      headerStyle={style.headerStyle}
      headerBodyStyle={style.headerBodyStyle}
      bodyStyle={style.modalBody}
      underLayerStyle={style.underLayer}
      close={props.close}
    >
      <div>
        <div style={{ margin: "16px", flexDirection: "row" }}>
          <Input
            name={"Enter PromoCode"}
            placeholder={"Enter PromoCode"}
            value={promoCode}
            className="defaultInput"
            onChange={(e) => {
              setPromoCode(e.target.value);
            }}
          />
          <Button
            type="primary"
            style={{
              width: "25%",
              height: 50,
              padding: "10px",
              margin: "16px",
            }}
            onClick={handleApplyPromocode}
          >
            Apply
          </Button>
        </div>
        <div style={style.row}>
          <div style={style.header}>Promocode Name</div>
          <div style={style.header}>Expires On</div>
          <div style={style.header}>Remaining Usage Limit</div>
          <div style={{ flex: 0.25 }} />
        </div>
        {props.packages.map((pack) => (
          <div key={pack.id} style={style.row}>
            <div style={style.column}>{pack.promocode.toUpperCase()}</div>
            <div style={style.column}>{pack.expiry}</div>
            <div style={style.column}>{pack.remainingUsageLimit}</div>
            <div style={{ flex: 0.25 }}>
              <img
                onClick={(e) => {
                  e.stopPropagation();
                  deletePromo(pack.promo_id);
                  // setShowEdit(!showEdit);
                  // setEditPackInfo(pack);
                }}
                src={DELETE_ICON}
                style={style.actionImage}
              />
            </div>
          </div>
        ))}
      </div>
    </ModalOverlay>
  );
};

export default AppliedPromos;

const EditPackageDetails = (props) => {
  const TITLE = "Edit Remaining Session";
  const LABEL_UPDATE = "UPDATE";

  let { id, remainingUsageLimit, totalPurchasedSessions } = props.pack
    ? props.pack
    : {};

  const [sessions, setSessions] = useState(remainingUsageLimit);

  const updateRemainingSession = async () => {
    if (sessions > totalPurchasedSessions) {
      toast.error(Constants.ENTER_VALID_REMAINING_USAGE_LIMIT, {
        autoClose: Constants.TOAST_TIME_OUT,
      });
      return;
    }
    const toastId = toast("Updating..");
    makeRequest("/admin/applied_promo", METHODS.PUT, {
      id,
      remainingUsageLimit: sessions,
    })
      .then((result) => {
        toast.dismiss(toastId);
        props.close();
        // Refresh get applied package details.
        props.refresh();
      })
      .catch((error) => {
        toast.dismiss(toastId);
        ERROR_HANDLE(error);
        return;
      });
  };

  return (
    <ModalOverlay
      modalStyle={style.modalStyle}
      header={TITLE}
      headerStyle={style.headerStyle}
      headerBodyStyle={style.headerBodyStyle}
      bodyStyle={style.modalBody}
      underLayerStyle={style.underLayer}
      close={props.close}
    >
      <div style={{ flex: 1 }}>
        <Input
          type="number"
          value={sessions}
          onChange={(e) => {
            setSessions(e.target.value);
          }}
          style={style.editInput}
        />
        <Button
          type="primary"
          onClick={updateRemainingSession}
          style={style.editButton}
        >
          {LABEL_UPDATE}
        </Button>
      </div>
    </ModalOverlay>
  );
};

const style = {
  modalStyle: {
    backgroundColor: theme.color.white,
    borderRadius: 3,
    paddingLeft: 50,
    paddingRight: 50,
  },
  underLayer: {
    backgroundColor: theme.color.shadowColor,
  },
  headerStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: theme.color.transparent,
  },
  headerBodyStyle: {
    width: "100%",
    height: 40,
    fontSize: 25,
    letterSpacing: 0,
    borderRadius: 3,
    lineHeight: "40px",
    fontFamily: theme.font.avenirBlackOblique,
    color: theme.color.thickGrey,
  },
  modalBody: {
    margin: 25,
    marginTop: 0,
    borderRadius: "0px 0px 15px 15px",
    backgroundColor: theme.color.transparent,
  },
  row: {
    display: "flex",
    alignItems: "center",
    width: 600,
    flexDirection: "row",
    marginTop: 20,
  },
  column: {
    flex: 1,
  },
  header: {
    alignSelf: "start",
    flex: 1,
    fontWeight: "bold",
  },
  actionImage: {
    alignSelf: "center",
    width: 30,
    height: 30,
  },
  editInput: {
    width: 100,
  },
  editButton: {
    marginTop: 10,
    width: 150,
  },
};
